import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next'; 
import { useHistory } from 'react-router-dom';

import Header from "./Header";
import useSound from "../../../../hooks/useSound";
import useCommonCode from '../../../../hooks/useCommonCode';
import { URL } from '../../../../constant';
import { useAiDiagnosisTestData, useUserInfo } from '../../../../hooks';

function EnterLearnerData() {
	const { AI_PREDICTION } = URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST;
	const history = useHistory();
	const { info } = useUserInfo();
	const { t } = useTranslation();
	const [cmnCd, setCmnCd] = useState("");
	const { codeList } = useCommonCode("DGNS_TARGT_GRADE_CD");
	const { setAiDiagnosisTestData } = useAiDiagnosisTestData();
	const { setSound, playSound, clearSound } = useSound();

	useEffect(() => {
		console.log("***** AI 진단테스트 페이지")
		setAiDiagnosisTestData({
			grade: '',
			year: '',
			yearLabel: '출생년도',
			month: '',
			monthLabel: '월',
			gender: ''
		});

		return () => {
			clearSound();
		}
	}, [])

	const onClickCmnCd = useCallback((e) => {
		setSound({ src: `${process.env.PUBLIC_URL}/static/audio/common_button.ogg` });
		playSound();
		setCmnCd(e.currentTarget.value);
	}, []);

	const handlePage = (type, path) => {
		if (type === 'next') {
			const { learnerBirth, learnerSex } = info;
			
			// setAiDiagnosisTestData({
			// 	grade: cmnCd,
			// 	year: learnerBirth,
			// 	gender: learnerSex,
			// 	selectLearning : 'course',
			// });
			history.replace({
				pathname: path,
				state: {
					aiDiagnosisTestData: {
						grade: cmnCd,
						year: learnerBirth,
						gender: learnerSex,
						selectLearning : 'course',
					}
				}
			});
		} else {
			history.push(path);
		}
	}


  return (
    <div className="layout-def layout-lc">
      <Header />
      <div className="container">
				<div className="inner">
					<div className="centermiddleBox gm">
						<div className="centermiddleBox-item">
							<div className="aic-choice-wrap">
								<div className="aic-choice-item">
									<h2 className="tit">
										{t("LC_02_04-GM.msg002")}
									</h2>
								</div>
								<div className="aic-choice-item">
									<div className="aic-choice-Btm">
										<ul className="custom-radio-wrap">
											{
												(codeList && codeList.length > 0) && (
													codeList.map((item, index) => {
														let isBr = false;
														// const idPreparing = _.indexOf(["GR16"], item.cmnCd) > -1;
														const idPreparing = _.indexOf([], item.cmnCd) > -1;
														
														if (item.cmnCd === 'GR12' || item.cmnCd === 'GR16') {
															isBr = true;
														}
														return (
															<React.Fragment key={item.cmnCd}>
																<li
																	className={clsx({
																		"js_play_audio1": true,
																		"yet": idPreparing
																	})}
																>
																	{
																		idPreparing
																		? (
																			<label>
																				<span className="state">준비중</span>
																				<span className="tit">{item.cdNm}</span>
																			</label>
																		)
																		: (
																			<>
																				<input
																					type="radio"
																					id={`aic-radio-2_${index}`}
																					name="aic-radio-2"
																					value={item.cmnCd}
																					checked={item.cmnCd === cmnCd}
																					onChange={onClickCmnCd}
																				/>
																				<label htmlFor={`aic-radio-2_${index}`}>{item.cdNm}</label>
																			</>		
																		)
																	}
																</li>
																{isBr && <br className="hide_tv hide_m" />}
															</React.Fragment>
														)
													})
												)
											}
										</ul>
									</div>
								</div>
								<div className="footer">
									<div className="footer-inner">
										<div className="d-flex">
											<div className="d-item btnItem-auto">
												<button
													className="btn btn-blue"
													disabled={!cmnCd}
													onClick={() => handlePage("next", AI_PREDICTION)}
												>
													{t("LC_02_04-GM.msg013")}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
    </div>
      
  );
}

export default EnterLearnerData;
